import { BaseModal } from "../../../../components/common/BaseModal/BaseModal";
import { LabeledSelect } from "../../../../components/common/LabeledSelect/LabeledSelect";
import { useUiTranslator } from "../../../../hooks/useUiTranslator";
import {
  Countries,
  useGetApiEasyAdministrationAreaCountryList,
} from "../../../../openapi/backendApi";
import { useAdministrationArea } from "../../../../providers/administrationAreaProvider";

import { JSX, useState } from "react";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";

export function AdministrationAreaDialog(): JSX.Element {
  const [isOpen, setIsOpen] = useState(true);
  const t = useUiTranslator();
  const {
    putAdministrationArea,
    administrationCountryIsoCode,
    handleChangeCountry,
  } = useAdministrationArea();

  /*  const [errorLoading, setErrorLoading] = useState(false); */

  const { data: countryList } = useGetApiEasyAdministrationAreaCountryList();

  /*   const { mutate: AskForQuotation } =
    usePostApiAskForQuotationAskForQuotationEmailWithJson(); */

  /*   function refetchAskForQuotation(): void {
    AskForQuotation(
      {
        data: {
          language: selectedLanguage?.languageCode?.split("-")[0],
        },
      },
      {
        onSuccess: (response) => {
          setErrorLoading(false);
          const countries = response?.data?.countries;
          if (countries) {
            setCountries(countries);
          }
        },
        onError: (e) => {
          setErrorLoading(true);
          console.error(e);
        },
      },
    );
  }
 */
  function handleConfirm(): void {
    putAdministrationArea(administrationCountryIsoCode);
  }

  const countries = (countryList?.data.countries as Countries[]) || [];
  return (
    <>
      <BaseModal
        title={t("CustomApp:dialog.administrationArea.header", "Location")}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        hideClose={true}
      >
        <Box sx={{ display: "flex", minWidth: "350px" }}>
          {/* {errorLoading && (
            <Box display="flex" justifyContent="center" alignItems={"end"}>
              <IconButton aria-label="reload" onClick={refetchAskForQuotation}>
                <RefreshIcon fontSize="inherit" />
              </IconButton>
            </Box>
          )} */}
          <LabeledSelect
            fullWidth={true}
            label={t("CustomApp:label.country", "Country")}
            value={administrationCountryIsoCode}
            handleChange={(val) => handleChangeCountry(val)}
            sx={{ width: "100%" }}
          >
            {countries && countries.length
              ? countries.map((country, idx) => {
                  return (
                    <MenuItem key={idx} value={country.value ?? ""}>
                      {country.label}
                    </MenuItem>
                  );
                })
              : null}
          </LabeledSelect>
        </Box>
        <Box display="flex" justifyContent="flex-end" pt={4}>
          <Button
            variant="contained"
            onClick={handleConfirm}
            disabled={!administrationCountryIsoCode}
          >
            {t("CustomApp:btn.setAdministrationArea", "Access")}
          </Button>
        </Box>
      </BaseModal>
    </>
  );
}
